<template>
  

      <!-- <div class="col-auto border-right">
        <div class="d-flex h-100">
          <div class="overview-EEI-title-fixed-width align-self-center">
            <p><strong>Employee Engagement Index</strong></p>
          </div>
          <div class="overview-EEI-chart-fixed-width align-self-center">
            <doughnutChart
              :chart-data="engagement.EmployeeEngagementIndex"
              :options="engagement.chartOptions"
              :textMiddle="engagement.EmployeeEngagementIndexValue"
            ></doughnutChart>
          </div>
        </div>
      </div> -->

      <div class="col-auto col-width-standard border-right">
        <div class="w-100 h-50 text-center">
          <strong>Employee Engagement Index</strong>
        </div>
        <div v-if="engagement.employeeEngagementChart" class="d-flex h-50 pb-4 align-items-center">
          <div class="overview-EEI-chart-fixed-width align-self-center">
            <doughnutChart
              :chart-data="engagement.employeeEngagementChart"
              :options="engagement.chartOptions"
              :textMiddle="engagement.employeeEngagement"
            ></doughnutChart>
          </div>
        </div>

        <div v-else class="d-flex h-50 pb-4 align-items-center">
         
            <p>Complete UWES and/or evaluation to see average</p>
          
        </div>
      </div>

      
    
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import {Doughnut,mixins} from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['engagement', 'chartData' ],
  components: {
    doughnutChart,
  },
  
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>